// extracted by mini-css-extract-plugin
module.exports = {"providerContainer":"Provider_providerContainer__EEmlg","partner":"Provider_partner__tso5X"};